module.exports = __webpack_public_path__ + "static/media/badlands-logo-dark.e2846d12.png";